export const plansOrder: string[] = ['quantum basic', 'quantum professional', 'quantum academia'];
